export default __webpack_public_path__ + "static/media/Dollar [Fill].76618289.svg";